<div class="dashboard-container">
  <!-- Header -->
  <app-staff-header [currentUser]="null" (logout)="goBack()">
  </app-staff-header>

  <!-- Main Content -->
  <div class="main-content">
    <!-- Navigation -->
    <app-staff-nav [isMobileMenuOpen]="false" (navigate)="goBack()" (closeMobileMenu)="goBack()">
    </app-staff-nav>

    <!-- Content Area -->
    <div class="content-area">
      <div class="container-fluid">

        <!-- Error State -->
        <div *ngIf="error" class="alert alert-danger" role="alert">
          <i class="bi bi-exclamation-triangle me-2"></i>{{ error }}
          <button type="button" class="btn btn-sm btn-outline-danger ms-3" (click)="goBack()">
            กลับไปหน้ารายการ
          </button>
        </div>

        <!-- Form Content -->
        <div *ngIf="!error" class="form-container">

          <!-- Page Header -->
          <div class="page-header mb-4">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <button type="button" class="btn btn-outline-secondary me-3" (click)="goBack()">
                  <i class="bi bi-arrow-left me-2"></i>กลับ
                </button>
                <div>
                  <h4 class="mb-1">
                    <i class="bi bi-file-earmark-text me-2"></i>รายละเอียดคำขอลงทะเบียนผู้ประเมินหลัก
                  </h4>
                  <p class="text-muted mb-0 small">
                    เลขที่คำขอ: <span class="fw-bold">{{ registrationForm.get('requestId')?.value }}</span>
                  </p>
                </div>
              </div>
              <div>
                <span class="badge" [ngClass]="getStatusBadgeClass()" style="font-size: 1rem; padding: 0.5rem 1rem;">
                  {{ getStatusLabel() }}
                </span>
              </div>
            </div>
          </div>

          <!-- Progress Bar -->
          <div class="modal-progress mb-4">
            <div class="progress">
              <div class="progress-bar bg-success" role="progressbar" [style.width.%]="getProgressPercentage()"
                [attr.aria-valuenow]="getProgressPercentage()" aria-valuemin="0" aria-valuemax="100">
              </div>
            </div>
            <div class="progress-steps">
              <div class="step-container">
                <div *ngFor="let step of [1, 2, 3]" class="step-item">
                  <div class="step-circle" [class.completed]="isStepCompleted(step)"
                    [class.current]="isStepCurrent(step)" [class.clickable]="step <= currentStep"
                    (click)="goToStep(step)">
                    <i *ngIf="isStepCompleted(step)" class="bi bi-check-lg"></i>
                    <i *ngIf="isStepCurrent(step)" class="{{ getStepIcon(step) }}"></i>
                    <span *ngIf="!isStepCompleted(step) && !isStepCurrent(step)">{{ step }}</span>
                  </div>
                  <div class="step-label">{{ getStepTitle(step) }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Form -->
          <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">

            <!-- Step 1: Personal Information (Read-Only) -->
            <div class="step-content" *ngIf="currentStep === 1">
              
              <!-- Personal Information Card -->
              <div class="card personal-info-card mb-4">
                <div class="card-header" style="background: linear-gradient(135deg, #6c757d 0%, #495057 100%);">
                  <div class="header-content">
                    <div class="header-icon">
                      <i class="bi bi-person-circle"></i>
                    </div>
                    <div class="header-text">
                      <h6>ข้อมูลส่วนตัว</h6>
                      <small>ข้อมูลส่วนตัวของผู้สมัคร</small>
                    </div>
                  </div>
                </div>
                <div class="card-body p-4">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label class="form-label">ชื่อ</label>
                      <input type="text" class="form-control" formControlName="firstName" readonly>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label class="form-label">นามสกุล</label>
                      <input type="text" class="form-control" formControlName="lastName" readonly>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label class="form-label"><i class="bi bi-card-text me-2"></i>เลขบัตรประชาชน</label>
                      <input type="text" class="form-control" formControlName="idCard" readonly>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label class="form-label"><i class="bi bi-telephone me-2"></i>เบอร์โทรศัพท์</label>
                      <input type="text" class="form-control" formControlName="phoneNumber" readonly>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label class="form-label"><i class="bi bi-envelope me-2"></i>อีเมล</label>
                      <input type="text" class="form-control" formControlName="email" readonly>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Registered Address Card -->
              <div class="card personal-info-card mb-4">
                <div class="card-header" style="background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);">
                  <div class="header-content">
                    <div class="header-icon">
                      <i class="bi bi-house-door"></i>
                    </div>
                    <div class="header-text">
                      <h6>ที่อยู่ตามทะเบียนบ้าน</h6>
                      <small>ที่อยู่ตามทะเบียนบ้านของผู้สมัคร</small>
                    </div>
                  </div>
                </div>
                <div class="card-body p-4">
                  <div class="row">
                    <div class="col-md-12 mb-3">
                      <label class="form-label">ที่อยู่</label>
                      <input type="text" class="form-control" formControlName="registeredHouseNumber" readonly>
                    </div>
                    <div class="col-md-3 mb-3">
                      <label class="form-label">ตำบล/แขวง</label>
                      <input type="text" class="form-control" formControlName="registeredSubdistrict" readonly>
                    </div>
                    <div class="col-md-3 mb-3">
                      <label class="form-label">อำเภอ/เขต</label>
                      <input type="text" class="form-control" formControlName="registeredDistrict" readonly>
                    </div>
                    <div class="col-md-3 mb-3">
                      <label class="form-label">จังหวัด</label>
                      <input type="text" class="form-control" formControlName="registeredProvince" readonly>
                    </div>
                    <div class="col-md-3 mb-3">
                      <label class="form-label">รหัสไปรษณีย์</label>
                      <input type="text" class="form-control" formControlName="registeredPostalCode" readonly>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Current Address Card -->
              <div class="card personal-info-card mb-4">
                <div class="card-header" style="background: linear-gradient(135deg, #28a745 0%, #20c997 100%);">
                  <div class="header-content">
                    <div class="header-icon">
                      <i class="bi bi-geo-alt"></i>
                    </div>
                    <div class="header-text">
                      <h6>ที่อยู่ปัจจุบัน</h6>
                      <small>ที่อยู่ปัจจุบันของผู้สมัคร</small>
                    </div>
                  </div>
                </div>
                <div class="card-body p-4">
                  <div class="row">
                    <div class="col-md-12 mb-3">
                      <label class="form-label">ที่อยู่</label>
                      <input type="text" class="form-control" formControlName="currentHouseNumber" readonly>
                    </div>
                    <div class="col-md-3 mb-3">
                      <label class="form-label">ตำบล/แขวง</label>
                      <input type="text" class="form-control" formControlName="currentSubdistrict" readonly>
                    </div>
                    <div class="col-md-3 mb-3">
                      <label class="form-label">อำเภอ/เขต</label>
                      <input type="text" class="form-control" formControlName="currentDistrict" readonly>
                    </div>
                    <div class="col-md-3 mb-3">
                      <label class="form-label">จังหวัด</label>
                      <input type="text" class="form-control" formControlName="currentProvince" readonly>
                    </div>
                    <div class="col-md-3 mb-3">
                      <label class="form-label">รหัสไปรษณีย์</label>
                      <input type="text" class="form-control" formControlName="currentPostalCode" readonly>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Valuation Experience Card -->
              <div class="card personal-info-card mb-4">
                <div class="card-header" style="background: linear-gradient(135deg, #6c757d 0%, #495057 100%);">
                  <div class="header-content">
                    <div class="header-icon">
                      <i class="bi bi-briefcase"></i>
                    </div>
                    <div class="header-text">
                      <h6>ประสบการณ์การประเมินมูลค่า</h6>
                      <small>ประสบการณ์การทำงานด้านการประเมินมูลค่า</small>
                    </div>
                  </div>
                </div>
                <div class="card-body p-4">
                  <div *ngIf="valuationExperienceList.length > 0; else noValuationExp">
                    <div *ngFor="let exp of valuationExperienceList; let i = index" class="mb-3 pb-3" 
                         [class.border-bottom]="i < valuationExperienceList.length - 1">
                      <div class="row">
                        <div class="col-md-4 mb-2">
                          <label class="form-label fw-semibold text-muted small">องค์กร</label>
                          <p class="mb-0">{{ exp.organization || '-' }}</p>
                        </div>
                        <div class="col-md-4 mb-2">
                          <label class="form-label fw-semibold text-muted small">ตำแหน่ง</label>
                          <p class="mb-0">{{ exp.position || '-' }}</p>
                        </div>
                        <div class="col-md-4 mb-2">
                          <label class="form-label fw-semibold text-muted small">จำนวนปี</label>
                          <p class="mb-0">{{ exp.years || '-' }} ปี</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-template #noValuationExp>
                    <div class="text-center text-muted py-3">
                      <i class="bi bi-inbox" style="font-size: 2rem;"></i>
                      <p class="mb-0 mt-2">ไม่มีข้อมูลประสบการณ์การประเมินมูลค่า</p>
                    </div>
                  </ng-template>
                </div>
              </div>

              <!-- Education Background Card -->
              <div class="card personal-info-card mb-4">
                <div class="card-header" style="background: linear-gradient(135deg, #28a745 0%, #20c997 100%);">
                  <div class="header-content">
                    <div class="header-icon">
                      <i class="bi bi-mortarboard"></i>
                    </div>
                    <div class="header-text">
                      <h6>ประวัติการศึกษา</h6>
                      <small>ประวัติการศึกษาของผู้สมัคร</small>
                    </div>
                  </div>
                </div>
                <div class="card-body p-4">
                  <div *ngIf="educationBackgroundList.length > 0; else noEducation">
                    <div *ngFor="let edu of educationBackgroundList; let i = index" class="mb-3 pb-3" 
                         [class.border-bottom]="i < educationBackgroundList.length - 1">
                      <div class="row">
                        <div class="col-md-5 mb-2">
                          <label class="form-label fw-semibold text-muted small">สถาบันการศึกษา</label>
                          <p class="mb-0">{{ edu.Institution || edu.institution || '-' }}</p>
                        </div>
                        <div class="col-md-4 mb-2">
                          <label class="form-label fw-semibold text-muted small">วุฒิการศึกษา/สาขา</label>
                          <p class="mb-0">{{ edu['Degree and Major'] || edu.degree || '-' }}</p>
                        </div>
                        <div class="col-md-3 mb-2">
                          <label class="form-label fw-semibold text-muted small">ปีที่จบ (พ.ศ.)</label>
                          <p class="mb-0">{{ edu['Year Complete'] || edu.year || '-' }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-template #noEducation>
                    <div class="text-center text-muted py-3">
                      <i class="bi bi-inbox" style="font-size: 2rem;"></i>
                      <p class="mb-0 mt-2">ไม่มีข้อมูลประวัติการศึกษา</p>
                    </div>
                  </ng-template>
                </div>
              </div>

              <!-- VAT Courses Card -->
              <div class="card personal-info-card mb-4">
                <div class="card-header" style="background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);">
                  <div class="header-content">
                    <div class="header-icon">
                      <i class="bi bi-book"></i>
                    </div>
                    <div class="header-text">
                      <h6>หัวข้ออบรม/สัมมนา ที่จัดโดย VAT และ กลต.</h6>
                      <small>คอร์สอบรมที่จัดโดย VAT และ กลต.</small>
                    </div>
                  </div>
                </div>
                <div class="card-body p-4">
                  <!-- Data Display -->
                  <div *ngIf="vatCoursesList.length > 0">
                    <div *ngFor="let course of vatCoursesList; let i = index" 
                         class="course-item mb-3 p-3 rounded border" 
                         style="background-color: #f8f9fa;">
                      <div class="row align-items-center">
                        <!-- Course Number Badge -->
                        <div class="col-auto">
                          <div class="badge bg-primary rounded-circle d-flex align-items-center justify-content-center" 
                               style="width: 40px; height: 40px; font-size: 1.1rem;">
                            {{ i + 1 }}
                          </div>
                        </div>
                        
                        <!-- Course Details -->
                        <div class="col">
                          <div class="row">
                            <div class="col-md-8 mb-2">
                              <label class="form-label fw-semibold text-muted small mb-1">
                                <i class="bi bi-mortarboard-fill me-1 text-primary"></i>ชื่อคอร์ส
                              </label>
                              <p class="mb-0 fw-semibold">{{ course.course?.title || course.courseName || '-' }}</p>
                            </div>
                            <div class="col-md-4 mb-2">
                              <label class="form-label fw-semibold text-muted small mb-1">
                                <i class="bi bi-clock-fill me-1 text-info"></i>จำนวน CPD (ชั่วโมง)
                              </label>
                              <p class="mb-0">
                                <span class="badge bg-info text-white px-3 py-2" style="font-size: 0.95rem;">
                                  {{ course.course?.duration || course.cpdHours || '0' }} ชั่วโมง
                                </span>
                              </p>
                            </div>
                          </div>
                          
                          <div class="row mt-2">
                            <div class="col-md-4 mb-2">
                              <label class="form-label fw-semibold text-muted small mb-1">
                                <i class="bi bi-calendar-check me-1 text-success"></i>วันที่เข้าอบรม
                              </label>
                              <p class="mb-0">{{ course.attendanceDate ? formatDate(course.attendanceDate) : '-' }}</p>
                            </div>
                            <div class="col-md-4 mb-2">
                              <label class="form-label fw-semibold text-muted small mb-1">
                                <i class="bi bi-calendar-event me-1 text-warning"></i>วันที่จบหลักสูตร
                              </label>
                              <p class="mb-0">{{ course.completionDate ? formatDate(course.completionDate) : '-' }}</p>
                            </div>
                            <div class="col-md-4 mb-2">
                              <label class="form-label fw-semibold text-muted small mb-1">
                                <i class="bi bi-check-circle-fill me-1 text-success"></i>สถานะ
                              </label>
                              <p class="mb-0">
                                <span class="badge text-white" 
                                      [class.bg-success]="course.isVerified === true"
                                      [class.bg-secondary]="course.isVerified === false || !course.isVerified">
                                  {{ course.isVerified === true ? '✅ ได้รับการยืนยันแล้ว' : '⏳ ยังไม่ได้รับการยืนยัน' }}
                                </span>
                              </p>
                            </div>
                          </div>

                          <!-- Additional Info if available -->
                          <div class="row mt-2" *ngIf="course.course?.description">
                            <div class="col-12">
                              <label class="form-label fw-semibold text-muted small mb-1">
                                <i class="bi bi-info-circle me-1 text-secondary"></i>รายละเอียด
                              </label>
                              <p class="mb-0 text-muted small">{{ course.course.description }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Total CPD Hours Summary -->
                    <div class="alert alert-info mt-3 mb-0" role="alert">
                      <div class="d-flex align-items-center">
                        <i class="bi bi-info-circle-fill me-2" style="font-size: 1.5rem;"></i>
                        <div>
                          <strong>รวมจำนวน CPD ทั้งหมด:</strong>
                          <span class="ms-2 badge bg-primary" style="font-size: 1rem;">
                            {{ calculateTotalCpdHours() }} ชั่วโมง
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Empty State -->
                  <div *ngIf="vatCoursesList.length === 0">
                    <div class="text-center text-muted py-4">
                      <i class="bi bi-inbox" style="font-size: 3rem; opacity: 0.5;"></i>
                      <p class="mb-0 mt-3 fw-semibold">ไม่มีข้อมูลคอร์สอบรม VAT และ กลต.</p>
                      <p class="mb-0 mt-1 small text-muted">ยังไม่มีการลงทะเบียนเข้าอบรมคอร์สใดๆ</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Special Courses Card -->
              <div class="card personal-info-card mb-4">
                <div class="card-header" style="background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%);">
                  <div class="header-content">
                    <div class="header-icon">
                      <i class="bi bi-journal-bookmark"></i>
                    </div>
                    <div class="header-text">
                      <h6>หัวข้ออบรม/สัมมนา ที่จัดโดยหน่วยงานอื่น</h6>
                      <small>คอร์สอบรมจากหน่วยงานภายนอก</small>
                    </div>
                  </div>
                </div>
                <div class="card-body p-4">
                  <div *ngIf="specialCoursesList.length > 0; else noSpecialCourses">
                    <div *ngFor="let course of specialCoursesList; let i = index" class="mb-3 pb-3" 
                         [class.border-bottom]="i < specialCoursesList.length - 1">
                      <div class="row">
                        <div class="col-md-4 mb-2">
                          <label class="form-label fw-semibold text-muted small">
                            <i class="bi bi-book me-1 text-primary"></i>หัวข้อหลักสูตร
                          </label>
                          <p class="mb-0">{{ course.courseTopic || '-' }}</p>
                        </div>
                        <div class="col-md-3 mb-2">
                          <label class="form-label fw-semibold text-muted small">
                            <i class="bi bi-building me-1 text-success"></i>หน่วยงาน/สถาบัน
                          </label>
                          <p class="mb-0">{{ course.organization || '-' }}</p>
                        </div>
                        <div class="col-md-2 mb-2">
                          <label class="form-label fw-semibold text-muted small">
                            <i class="bi bi-clock me-1 text-info"></i>CPD (ชั่วโมง)
                          </label>
                          <p class="mb-0">{{ course.cpdHours || '-' }} ชั่วโมง</p>
                        </div>
                        <div class="col-md-3 mb-2">
                          <label class="form-label fw-semibold text-muted small">
                            <i class="bi bi-calendar-event me-1 text-warning"></i>วันที่เข้ารับการอบรม
                          </label>
                          <p class="mb-0">{{ course.trainingDate ? formatDate(course.trainingDate) : '-' }}</p>
                        </div>
                      </div>
                      <div class="row mt-2" *ngIf="course.status">
                        <div class="col-md-12">
                          <label class="form-label fw-semibold text-muted small">
                            <i class="bi bi-check-circle me-1 text-success"></i>สถานะการอบรม
                          </label>
                          <p class="mb-0">
                            <span class="badge" 
                                  [class.bg-success]="course.status === 'completed'"
                                  [class.bg-info]="course.status === 'in-progress'"
                                  [class.bg-warning]="course.status === 'pending'">
                              {{ course.status === 'completed' ? '✅ เสร็จสิ้นแล้ว' : 
                                 course.status === 'in-progress' ? '🔄 กำลังดำเนินการ' : 
                                 course.status === 'pending' ? '⏳ รอดำเนินการ' : course.status }}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-template #noSpecialCourses>
                    <div class="text-center text-muted py-3">
                      <i class="bi bi-inbox" style="font-size: 2rem;"></i>
                      <p class="mb-0 mt-2">ไม่มีข้อมูลคอร์สอบรมจากหน่วยงานอื่น</p>
                    </div>
                  </ng-template>
                </div>
              </div>

              <!-- Info Alert -->
              <div class="alert alert-info">
                <div class="d-flex align-items-center">
                  <i class="bi bi-info-circle-fill me-3" style="font-size: 2rem;"></i>
                  <div>
                    <strong>ข้อมูลแบบอ่านอย่างเดียว</strong>
                    <p class="mb-0 mt-1">ข้อมูลในหน้านี้เป็นข้อมูลที่ผู้สมัครกรอกในแบบฟอร์ม ไม่สามารถแก้ไขได้ในหน้านี้ กรุณากดปุ่ม "ถัดไป" เพื่อดำเนินการต่อ</p>
                  </div>
                </div>
              </div>

            </div>

            <!-- Step 2: Review and Confirm -->
            <div class="step-content" *ngIf="currentStep === 2">
              <div class="card personal-info-card">
                <div class="card-header" style="background: linear-gradient(135deg, #28a745 0%, #20c997 100%);">
                  <div class="header-content">
                    <div class="header-icon">
                      <i class="bi bi-check-circle"></i>
                    </div>
                    <div class="header-text">
                      <h6>ตรวจสอบและยืนยันข้อมูล</h6>
                      <small>ตรวจสอบความถูกต้องและอัปเดตสถานะ</small>
                    </div>
                  </div>
                </div>
                <div class="card-body p-4">
                  <div class="review-section">
                    <h6 class="section-title"><i class="bi bi-file-earmark-check me-2"></i>ข้อมูลการสมัคร</h6>
                    <div class="review-grid">
                      <div class="review-item">
                        <label>ประเภทสมาชิก:</label>
                        <span>{{ getAppraiserLevelLabel() }}</span>
                      </div>
                      <div class="review-item">
                        <label>ค่าธรรมเนียม:</label>
                        <span>{{ registrationForm.get('feeAmount')?.value | number:'1.2-2' }} บาท</span>
                      </div>
                    </div>

                    <hr class="my-4">

                    <h6 class="section-title"><i class="bi bi-pencil-square me-2"></i>อัปเดตสถานะคำขอ</h6>
                    <div class="alert alert-warning mb-3">
                      <i class="bi bi-exclamation-triangle me-2"></i>
                      <strong>สำคัญ:</strong> กรุณาเลือกสถานะที่เหมาะสมก่อนบันทึกข้อมูล
                    </div>
                    <div class="row">
                      <div class="col-md-12 mb-3">
                        <label class="form-label required"><i class="bi bi-clipboard-check me-2"></i>สถานะคำขอ</label>
                        <select class="form-select form-select-lg" formControlName="status"
                          [class.is-invalid]="hasError('status')">
                          <option *ngFor="let status of statusOptions" [value]="status.value">{{ status.label }}
                          </option>
                        </select>
                        <div class="invalid-feedback" *ngIf="hasError('status')">
                          {{ getErrorMessage('status') }}
                        </div>
                        <small class="text-muted d-flex align-items-center mt-2">
                          <i class="bi bi-info-circle me-1"></i>
                          เลือกสถานะที่ต้องการอัปเดตสำหรับคำขอนี้
                        </small>
                      </div>
                      <div class="col-md-12 mb-3">
                        <label class="form-label"><i class="bi bi-credit-card me-2"></i>กรอกเลขที่บัตรผู้ประเมินหลัก</label>
                        <input type="text" class="form-control form-control-lg" formControlName="cardNumber"
                          placeholder="กรอกเลขที่บัตรผู้ประเมินหลัก">
                        <small class="text-muted d-flex align-items-center mt-2">
                          <i class="bi bi-info-circle me-1"></i>
                          กรอกเลขที่บัตรผู้ประเมินหลักหากมีการออกบัตรแล้ว
                        </small>
                      </div>
                      <div class="col-md-12 mb-3">
                        <label class="form-label"><i class="bi bi-calendar-event me-2"></i>วันหมดอายุบัตรผู้ประเมินหลัก</label>
                        <input type="date" class="form-control form-control-lg" formControlName="cardExpiryDate">
                        <small class="text-muted d-flex align-items-center mt-2">
                          <i class="bi bi-info-circle me-1"></i>
                          เลือกวันหมดอายุของบัตรผู้ประเมินหลัก
                        </small>
                      </div>
                    </div>

                    <hr class="my-4">

                    <!-- Documents Section -->
                    <h6 class="section-title"><i class="bi bi-file-earmark-text me-2"></i>เอกสารประกอบการสมัคร</h6>
                    <div *ngIf="documents && documents.length > 0" class="documents-section mb-4">
                      <div class="row">
                        <div class="col-md-6 mb-3" *ngFor="let doc of documents; let i = index">
                          <div class="card document-card h-100">
                            <div class="card-body">
                              <div class="d-flex align-items-start">
                                <div class="document-icon me-3">
                                  <i class="bi {{ getFileIcon(doc.name) }}" style="font-size: 2.5rem;"></i>
                                </div>
                                <div class="flex-grow-1">
                                  <h6 class="mb-2">{{ doc.name }}</h6>
                                  
                                  <!-- Image Preview -->
                                  <div *ngIf="isImageFile(doc.name)" class="document-preview mb-3">
                                    <img [src]="doc.file" [alt]="doc.name" class="img-fluid rounded" 
                                      style="max-height: 200px; cursor: pointer;" 
                                      (click)="openDocument(doc.file)">
                                  </div>
                                  
                                  <!-- PDF Preview -->
                                  <div *ngIf="isPdfFile(doc.name)" class="document-preview mb-3">
                                    <div class="pdf-preview-container" style="height: 200px; border: 1px solid #dee2e6; border-radius: 0.375rem; overflow: hidden;">
                                      <iframe [src]="doc.file | safe: 'resourceUrl'" 
                                        style="width: 100%; height: 100%; border: none;">
                                      </iframe>
                                    </div>
                                  </div>
                                  
                                  <!-- Action Buttons -->
                                  <div class="d-flex gap-2">
                                    <button type="button" class="btn btn-sm btn-outline-primary" 
                                      (click)="openDocument(doc.file)">
                                      <i class="bi bi-eye me-1"></i>ดูเอกสาร
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- No Documents Message -->
                    <div *ngIf="!documents || documents.length === 0" class="alert alert-info">
                      <i class="bi bi-info-circle me-2"></i>
                      ไม่มีเอกสารประกอบการสมัคร
                    </div>

                    <hr class="my-4">

                    <h6 class="section-title"><i class="bi bi-person-circle me-2"></i>ข้อมูลส่วนตัว</h6>
                    <div class="review-grid">
                      <div class="review-item">
                        <label>ชื่อ-นามสกุล:</label>
                        <span>
                          {{ registrationForm.get('titleName')?.value }}
                          {{ registrationForm.get('firstName')?.value }}
                          {{ registrationForm.get('lastName')?.value }}
                        </span>
                      </div>
                      <div class="review-item">
                        <label>เลขบัตรประชาชน:</label>
                        <span>{{ registrationForm.get('idCard')?.value }}</span>
                      </div>
                      <div class="review-item">
                        <label>อีเมล:</label>
                        <span>{{ registrationForm.get('email')?.value }}</span>
                      </div>
                      <div class="review-item">
                        <label>โทรศัพท์:</label>
                        <span>{{ registrationForm.get('phoneNumber')?.value }}</span>
                      </div>
                    </div>

                    <hr class="my-4">

                    <div class="alert alert-success">
                      <div class="d-flex align-items-center">
                        <i class="bi bi-check-circle-fill me-3" style="font-size: 2rem;"></i>
                        <div>
                          <strong>พร้อมบันทึกข้อมูล</strong>
                          <p class="mb-0 mt-1">กรุณาตรวจสอบข้อมูลให้ถูกต้องและเลือกสถานะที่เหมาะสมก่อนกดปุ่ม
                            "บันทึกข้อมูล"</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Step 3: Payment Status -->
            <div class="step-content" *ngIf="currentStep === 3">
              <div class="card personal-info-card">
                <div class="card-header" style="background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%);">
                  <div class="header-content">
                    <div class="header-icon">
                      <i class="bi bi-credit-card"></i>
                    </div>
                    <div class="header-text">
                      <h6>ข้อมูลการชำระเงิน</h6>
                      <small>ตรวจสอบหลักฐานการโอนได้ที่นี่ การปรับสถานะทำที่เมนู "ตรวจสอบการชำระเงิน"</small>
                    </div>
                  </div>
                </div>
                <div class="card-body p-4">
                  <div class="alert alert-info mb-3">
                    <i class="bi bi-lock-fill me-2"></i>
                    <strong>หมายเหตุ:</strong> สถานะการชำระเงินและการออกใบเสร็จอยู่ในความดูแลของฝ่ายการเงิน
                    ปรับได้ที่เมนู "ตรวจสอบการชำระเงิน"
                  </div>

                  <div class="row">
                    <div class="col-md-12 mb-3">
                      <label class="form-label"><i class="bi bi-cash-coin me-2"></i>สถานะการชำระเงิน</label>
                      <div>
                        <span class="badge bg-secondary fs-6 py-2 px-3">{{ paymentStatusDisplay }}</span>
                      </div>
                      <small class="text-muted d-flex align-items-center mt-2">
                        <i class="bi bi-info-circle me-1"></i>
                        ฝ่ายการเงินเป็นผู้ตรวจสอบหลักฐานการโอนและปรับสถานะการชำระเงิน
                      </small>

                      <!-- เลขที่ใบเสร็จที่ออกแล้ว (ออกจากเมนูตรวจสอบการชำระเงิน) -->
                      <div *ngIf="existingCodeReceipt"
                           class="mt-3 p-3 rounded border border-success bg-success bg-opacity-10 d-flex align-items-center gap-2">
                        <i class="bi bi-receipt-cutoff text-success fs-5"></i>
                        <span class="fw-semibold text-success">รหัสใบเสร็จ:</span>
                        <span class="fw-bold text-dark font-monospace">{{ existingCodeReceipt }}</span>
                      </div>
                    </div>
                  </div>

                  <hr class="my-4">

                  <!-- Payment Slip Preview Section -->
                  <h6 class="section-title mb-3">
                    <i class="bi bi-receipt me-2"></i>หลักฐานการชำระเงิน
                  </h6>

                  <div *ngIf="hasPaymentSlip()" class="payment-slip-section">
                    <div class="card border-0 shadow-sm">
                      <div class="card-body p-0">
                        <!-- Payment Slip Image Preview -->
                        <div class="payment-slip-preview position-relative">
                          <img [src]="paymentSlip"
                               alt="หลักฐานการชำระเงิน"
                               class="img-fluid w-100 rounded-top"
                               style="max-height: 500px; object-fit: contain; background-color: #f8f9fa; cursor: pointer;"
                               (click)="openPaymentSlipPreview()">

                          <!-- Overlay on hover -->
                          <div class="preview-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                               (click)="openPaymentSlipPreview()">
                            <div class="text-center text-white">
                              <i class="bi bi-zoom-in" style="font-size: 3rem;"></i>
                              <p class="mt-2 mb-0 fw-bold">คลิกเพื่อดูขนาดเต็ม</p>
                            </div>
                          </div>
                        </div>

                        <!-- Action Buttons -->
                        <div class="card-footer bg-white border-0 p-3">
                          <div class="d-flex gap-2 justify-content-center">
                            <button type="button"
                                    class="btn btn-primary btn-lg"
                                    (click)="openPaymentSlipPreview()">
                              <i class="bi bi-eye me-2"></i>ดูหลักฐานการชำระเงิน
                            </button>
                            <button type="button"
                                    class="btn btn-outline-secondary btn-lg"
                                    (click)="openDocument(paymentSlip)">
                              <i class="bi bi-box-arrow-up-right me-2"></i>เปิดในแท็บใหม่
                            </button>
                          </div>

                          <!-- Info Alert -->
                          <div class="alert alert-info mt-3 mb-0">
                            <div class="d-flex align-items-start">
                              <i class="bi bi-info-circle-fill me-2 mt-1"></i>
                              <div class="small">
                                <strong>คำแนะนำ:</strong> กรุณาตรวจสอบหลักฐานการชำระเงินให้ครบถ้วนก่อนอัปเดตสถานะการชำระเงิน
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- No Payment Slip Message -->
                  <div *ngIf="!hasPaymentSlip()" class="alert alert-warning">
                    <div class="d-flex align-items-center">
                      <i class="bi bi-exclamation-triangle-fill me-3" style="font-size: 2rem;"></i>
                      <div>
                        <strong>ไม่พบหลักฐานการชำระเงิน</strong>
                        <p class="mb-0 mt-1 small">ผู้สมัครยังไม่ได้อัปโหลดหลักฐานการชำระเงิน กรุณาติดต่อผู้สมัครเพื่อขอหลักฐานการชำระเงิน</p>
                      </div>
                    </div>
                  </div>

                  <hr class="my-4">

                  <div class="alert alert-success">
                    <div class="d-flex align-items-center">
                      <i class="bi bi-check-circle-fill me-3" style="font-size: 2rem;"></i>
                      <div>
                        <strong>พร้อมบันทึกข้อมูล</strong>
                        <p class="mb-0 mt-1">กรุณาตรวจสอบข้อมูลให้ถูกต้องและเลือกสถานะที่เหมาะสมก่อนกดปุ่ม
                          "บันทึกข้อมูล"</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Navigation Buttons -->
            <div class="form-navigation mt-4">
              <div class="d-flex justify-content-between">
                <button type="button" class="btn btn-outline-secondary" *ngIf="currentStep > 1" (click)="prevStep()">
                  <i class="bi bi-arrow-left me-2"></i>ย้อนกลับ
                </button>
                <div class="ms-auto">
                  <button type="button" class="btn btn-outline-secondary me-2" (click)="goBack()">
                    ยกเลิก
                  </button>
                  <button type="button" class="btn btn-primary" *ngIf="currentStep < totalSteps" (click)="nextStep()">
                    ถัดไป<i class="bi bi-arrow-right ms-2"></i>
                  </button>
                  <button type="submit" class="btn btn-success" *ngIf="currentStep === totalSteps"
                    [disabled]="isSubmitting">
                    <span *ngIf="!isSubmitting">
                      <i class="bi bi-check-circle me-2"></i>บันทึกข้อมูล
                    </span>
                    <span *ngIf="isSubmitting">
                      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      กำลังบันทึก...
                    </span>
                  </button>
                </div>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>